// extracted by mini-css-extract-plugin
export var banner = "_me-0";
export var settingRow = "_me-2";
export var titleIcon = "_me-1";